import styled from "styled-components";
import { breakpoints } from "definitions";

/* La barra de acciones tenía `flex-direction: row-reverse` con el checkbox de
   términos a un lado y los botones al otro, así que la leyenda que hay que
   aceptar quedaba lejos del botón que la usa. Ahora el checkbox va arriba, a
   todo el ancho, y debajo las acciones: primero las del formulario, y la
   navegación separada a la derecha. */

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
  margin-top: 2.2rem;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  width: 100%;

  ${breakpoints.tablet} {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

export const ActionGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  ${breakpoints.tablet} {
    flex-direction: column;
    align-items: stretch;

    > * {
      width: 100%;
    }
  }
`;
